type LogLevel = "info" | "warn" | "error";

const SENSITIVE_KEYS = [
  "message",
  "personalNote",
  "memory",
  "insideJoke",
  "recipientImage",
  "encryptedMessage",
  "encryptedPersonalNote",
  "encryptedMemory",
  "encryptedInsideJoke",
  "passcode",
  "fragmentKey",
  "encryptedKey",
  "token",
  "authorization",
  "email",
];

function redactValue(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(redactValue);

  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>).map(([key, val]) => {
        const isSensitive = SENSITIVE_KEYS.some((sensitive) =>
          key.toLowerCase().includes(sensitive.toLowerCase())
        );

        return [key, isSensitive ? "[REDACTED]" : redactValue(val)];
      })
    );
  }

  return value;
}

class PrivacyLoggerService {
  private shouldLog() {
    return process.env.NODE_ENV !== "production";
  }

  private log(level: LogLevel, message: string, metadata?: unknown) {
    if (!this.shouldLog()) return;

    const safeMetadata = metadata ? redactValue(metadata) : undefined;

    if (level === "error") {
      console.error(`[LRNSY:${level}] ${message}`, safeMetadata || "");
      return;
    }

    if (level === "warn") {
      console.warn(`[LRNSY:${level}] ${message}`, safeMetadata || "");
      return;
    }

    console.log(`[LRNSY:${level}] ${message}`, safeMetadata || "");
  }

  info(message: string, metadata?: unknown) {
    this.log("info", message, metadata);
  }

  warn(message: string, metadata?: unknown) {
    this.log("warn", message, metadata);
  }

  error(message: string, metadata?: unknown) {
    this.log("error", message, metadata);
  }
}

export const privacyLogger = new PrivacyLoggerService();
